import React from "react";
import { Link } from "react-router-dom";
import "./CardTask.css";
//import './App.css';
import "../look/look";
import Look from "../look/look";
class CardDescriptions extends React.Component {
  state = {
    hidden: 0
  };
  componentDidMount() {
    
    if (this.props.way === "") {
      this.setState({
        hidden: 1
      });
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="card-list">
          <div className="card-list-head">
            <h5>{this.props.title}</h5>
          </div>

          <div className="card card-task">
            <div className="progress">
              <div
                className={
                  "progress-bar " +
                  (this.props.status === "Concluído" ||
                  this.props.status === "Concluido"
                    ? "bg-successs"
                    : "bg-danger")
                }
                role="progressbar"
                style={{ width: "50%", marginLeft: "-2px" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <div className="card-body">
              <div className="card-title">
                <span>
                  <h6 data-filter-by="text">{this.props.status}</h6>
                </span>
              </div>
              <div className="card-meta">
                <div className="dropdown card-options">
                  {this.state.hidden === 0 && (
                    <Link to={`${this.props.way}`}>
                      <Look width="28" height="24" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="card card-task">
            <div className="progress">
              <div
                className="progress-bar bg-success"
                role="progressbar"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CardDescriptions;
